/**
 * MPS AI 챗 summary 필드 키를 모바일 표시 라벨로 변환한다.
 * 우선순위: 도메인 전용 > common > fallback.
 */
export const MPS_AI_SUMMARY_LABELS = {
  common: {
    구분: '구분',
    건수: '건수',
    count: '건수',
    cnt: '건수',
    metric: '항목',
    값: '값',
    value: '값',
  },
  billing: {
    totalReqPrice: '매출 금액',
    totalPrice: '납부 금액',
    totalBalance: '잔액',
    totalCount: '건수',
  },
  cms_member: {
    count: '건수',
    accCount: '거래처',
    readyCount: '신청대기',
    failCount: '승인불가',
    successCount: '정상승인',
  },
  receivables: {
    totalCount: '건수',
    rentalReqPrice: '임대 매출금액',
    salesReqPrice: '전표 매출금액',
    totalReqPrice: '합계 매출금액',
    rentalPrice: '임대 수금액',
    salesPrice: '전표 수금액',
    totalPrice: '합계 수금액',
    rentalBalance: '임대 매출잔액',
    salesBalance: '전표 매출잔액',
    totalBalance: '합계 잔액',
    purchaseReqPrice: '전표 매입금액',
    purchasePrice: '매입 수금액',
    purchaseBalance: '전표매입잔액',
  },
  toner: {
    totalCnt: '전체 건수',
    totalBlackCnt: 'BLACK',
    totalCyanCnt: 'CYAN',
    totalMagentaCnt: 'MAGENTA',
    totalYellowCnt: 'YELLOW',
  },
  voucher: {
    totalCount: '총 건수',
    purchaseCount: '매입 건수',
    salesCount: '매출 건수',
    estimateCount: '견적 건수',
    orderCount: '발주 건수',
    statementTotalAmount: '전표 청구 합계',
    purchaseAmount: '매입 청구 금액',
    salesAmount: '매출 청구 금액',
    purchaseBalance: '매입 잔액',
    salesBalance: '매출 잔액',
    estimateAmount: '견적 금액',
    orderAmount: '발주 금액',
    purchaseCompleteAmount: '매입 결제(수금) 금액',
    salesCompleteAmount: '매출 결제(지급) 금액',
    purchaseRefundAmount: '매입 환급 금액',
    salesRefundAmount: '매출 환불 금액',
  },
  estimate_order: {
    totalCount: '총 건수',
    estimateCount: '견적 건수',
    orderCount: '발주 건수',
    estimateAmount: '견적 금액',
    orderAmount: '발주 금액',
  },
  cms_payment: {
    totalCount: '총 건수',
    etcCount: '기타수납',
    cmsCount: 'CMS',
    bankCount: '이체',
    cardCount: '카드',
    successCount: '성공',
    readyCount: '처리중',
    cancelCount: '취소',
    failCount: '실패',
    salesCallAmount: '매출 청구 금액',
    salesActualAmount: '매출 납부 금액',
    salesRefundCallAmount: '매출 청구 환불',
    salesRefundActualAmount: '매출 납부 환불',
    purchaseCallAmount: '매입 청구 금액',
    purchaseActualAmount: '매입 납부 금액',
    purchaseRefundCallAmount: '매입 청구 환불',
    purchaseRefundActualAmount: '매입 납부 환불',
    paymentFee: '수수료',
  },
  account_list: {
    cnt: '건수',
    contractFeeSum: '요금 합',
    cmsCountSum: 'CMS 합',
    taxCountSum: 'TAX 합',
    outstandingCount: '미수 거래처수',
    sumBalanceTotal: '미납금액 합',
  },
  monthly_usage_history: {
    count: '건수',
    baseFeeSum: '기본요금 합계',
    additionalFeeSum: '추가요금 합계',
    additionalMonoCntSum: '흑백 추가매수 합계',
    additionalColorCntSum: '컬러 추가매수 합계',
  },
  monthly_usage_manage: {
    count: '건수',
    baseFeeSum: '기본요금 합계',
    additionalFeeSum: '추가요금 합계',
    additionalMonoCntSum: '흑백 추가매수 합계',
    additionalColorCntSum: '컬러 추가매수 합계',
  },
  talk: {
    totalCount: '전체 건수',
    complete: '발송 완료',
    ready: '대기·진행',
    kakaoSuccess: '카카오 성공',
    smsSuccess: '대체 문자 성공',
    finalFail: '최종 실패',
  },
}

export function resolveMpsAiSummaryFieldLabel(domain, fieldKey) {
  const k = (fieldKey || '').toString()
  if (!k) return null
  const d = (domain || '').trim().toLowerCase()
  const per = MPS_AI_SUMMARY_LABELS[d] || {}
  if (per[k]) return per[k]
  const common = MPS_AI_SUMMARY_LABELS.common || {}
  if (common[k]) return common[k]
  return null
}

export function fallbackMpsAiSummaryFieldLabel(key) {
  const k = (key || '').toString()
  if (!k) return ''
  return k
    .replace(/_/g, ' ')
    .replace(/\bcnt\b/gi, '건수')
    .replace(/\bcount\b/gi, '건수')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim()
}
